import { backgroundTransitionOnClick, flex, Input, pointer, singleTextEllipsis } from '@byecode/ui'
import styled from 'styled-components'

import { Icon } from '../../style'

export const TopBlock = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const DragContainer = styled.div``

export const RightItem = styled.div`
    flex-shrink: 0;
    ${flex}
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
`

export const ListItem = styled.div`
    position: relative;
    width: 100%;
    padding: 6px 10px 0 8px;
    height: 32px;
    font-size: var(--font-size-normal);
    font-style: normal;
    font-weight: 400;
    border-radius: 6px;
    z-index: 0;
    outline: none;
    color: var(--color-gray-700);
    ${pointer}

    &:hover ${Icon} {
        visibility: visible;
    }

    ${backgroundTransitionOnClick}

    &.active {
        color: var(--color-main);
        background-color: var(--color-main-tint);
    }

    .dotsThree {
        /* display: none; */
        visibility: hidden;
        order: -1;
    }

    .activeDots {
        order: 5;
        visibility: visible;
    }

    :hover {
        .dotsThree {
            order: 5;
            visibility: visible;
        }
    }
`

export const Name = styled.div`
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    flex: 1;

    ${singleTextEllipsis}
`

export const LeftItem = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    gap: 4px;
    overflow: hidden;
`

export const TitleInput = styled.div`
    flex: 1;
    height: 20px;
    line-height: 20px;
    font-size: var(--font-size-normal);
    overflow: hidden;

    input {
        width: 100%;
    }
`

export const Item = styled.div`
    display: flex;
    align-items: center;
    height: 32px;
    justify-content: space-between;
    padding: 0 16px;
    ${pointer}
    :hover {
        background-color: var(--color-gray-100);
    }
    &.active {
        background-color: var(--color-gray-100);
    }
`
